// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__nJ6ov","approved":"Status_approved__NUQqC","rejected":"Status_rejected__-BNEU","expired":"Status_expired__1KC5o","label":"Status_label__1Vq49"};